<template>
  <div class="contentPane">
    <ActiveContent :userData="userData" :organizationData="organizationData" />
    <!-- <GateModal :keyData="keyData" :userData="userData" :organizationData="organizationData" /> -->
    <!-- <UnitModal :userData="userData" :organizationData="organizationData" /> -->
    <!-- <IncidentModal :incident="incidentData" :userData="userData" :organizationData="organizationData" /> -->
    <CreateVisitorSelectorModal :userData="userData" :organizationData="organizationData" />
    <CreateEntryLog :userData="userData" :organizationData="organizationData" />
    <CreateKeyModal :userData="userData" :organizationData="organizationData" />
    <CreatePartyKeyModal :userData="userData" :organizationData="organizationData" />
    <CreateFrequentVisitorModal :userData="userData" :organizationData="organizationData" />
    <CreateBlockedVisitorModal :userData="userData" :organizationData="organizationData" />
    <CreateVisitorModal :organizationData="organizationData" />
    <CreateIncidentModal :userData="userData" :organizationData="organizationData" />
    <CreateViolationModal :userData="userData" :organizationData="organizationData" />
    <CreateUserModal :userData="userData" :organizationData="organizationData" />
    <CreateVehicleModal :userData="userData" :organizationData="organizationData" />
    <CreateVendorModal :userData="userData" :organizationData="organizationData" />
    <CreatePetModal :userData="userData" :organizationData="organizationData" />
    <CreateMaintenanceModal :userData="userData" :organizationData="organizationData" />
    <ScanKeyModal :userData="userData" :organizationData="organizationData" />
  </div>
</template>

<script>
import { isMobile, isTablet } from 'mobile-device-detect';
import ActiveContent from "./ActiveContent.vue";
import CreateVisitorModal from "./modals/CreateVisitorModal.vue";
import CreateIncidentModal from "./modals/CreateIncidentModal.vue";
import IncidentModal from "./modals/IncidentModal.vue";
import EventBus from "../eventBus.js";
import * as Constants from "../js/constants.js"
import GateModal from "./modals/GateModal.vue";
import CreateViolationModal from "./modals/CreateViolationModal.vue";
import CreateUserModal from "./modals/CreateUserModal.vue";
import CreateVehicleModal from "./modals/CreateVehicleModal.vue";
import CreateVendorModal from "./modals/CreateVendorModal.vue";
import CreatePetModal from "./modals/CreatePetModal.vue";
import ScanKeyModal from "./modals/ScanKeyModal.vue";
import CreateVisitorSelectorModal from "./modals/CreateVisitorSelectorModal.vue";
import CreateEntryLog from "./modals/CreateEntryLog.vue";
import CreateKeyModal from "./modals/CreateKeyModal.vue";
import CreateFrequentVisitorModal from "./modals/CreateFrequentVisitorModal.vue";
import CreatePartyKeyModal from "./modals/CreatePartyKeyModal.vue";
import CreateMaintenanceModal from "./modals/CreateMaintenanceModal.vue";
import CreateBlockedVisitorModal from "./modals/CreateBlockedVisitorModal.vue";
// import SelectFiltersModal from "./modals/SelectFiltersModal.vue";
// import UnitModal from "./modals/UnitModal.vue";



export default {
  name: "Content-Pane",
  components: {
    ActiveContent,
    CreateVisitorSelectorModal,
    CreateVisitorModal,
    CreateEntryLog,
    CreateKeyModal,
    CreatePartyKeyModal,
    CreateFrequentVisitorModal,
    CreateBlockedVisitorModal,
    CreateIncidentModal,
    CreateViolationModal,
    CreateUserModal,
    CreateVehicleModal,
    CreatePetModal,
    CreateVendorModal,
    CreateMaintenanceModal,
    // IncidentModal,
    ScanKeyModal,
    // GateModal,
    // SelectFiltersModal,
    // UnitModal
  },
  props: ['userData', 'organizationData'],
  data() {
    return {
      incidentData: {
        "incident_id": 38,
        "incident_type": "Assault",
        "title": "Jason Test Incident",
        "description": "At 8:30 am, resident Richard Dale slipped at the Nautica Pool. He was running on the pool deck and fell by the showers.\nRichard was drinking and this might have been the reason for the fall. Paramedics were called since he cracked open his head",
        "reporter": "fa9c6911-44e8-4cf6-9cfd-96b089c95be9",
        "reporter_name": "Jason Quintana",
        "resident_uid": "fa9c6911-44e8-4cf6-9cfd-96b089c95be9",
        "current_status": "IN PROGRESS",
        "priority": "Urgent",
        "location": "Pool",
        "time_created": "2024-12-18T16:25:54.000Z",
        "time_acknowledged": null,
        "time_last_updated": "2024-12-18T16:25:54.000Z",
        "time_closed": null,
        "closed": 0,
        "closed_reason": null
      },
      keyData: {},
      // keyData: {
      //   "uid": "2296a6b5-65fb-49a9-84e6-f2465a7b13c0",
      //   "user_first_name": "Richard",
      //   "user_last_name": "Dale",
      //   "subdivision": "Fantasy Isle",
      //   "key_id": "bc83af3044e4",
      //   "key_type": "Frequent Visitor",
      //   "visitor_last_name": "Quintana",
      //   "visitor_first_name": "Jason",
      //   "visitor_phone_number": "+19548052619",
      //   "visitor_email": "",
      //   "business_name": "",
      //   "time_created": "2025-03-02T20:50:44.000Z",
      //   "date_of_visit": "2025-03-02T20:50:44.000Z",
      //   "time_active": "2025-03-02T20:50:44.000Z",
      //   "expiration_time": "2025-03-03T00:00:00.000Z",
      //   "time_expired": "2025-03-03T00:00:00.000Z",
      //   "visitor_relationship": "Guest",
      //   "business_type": "Vendor",
      //   "special_instructions": "Made From Gatewatch",
      //   "visitor_expiration_date": "2025-03-03T00:00:00.000Z",
      //   "visitor_restrictions": "None",
      //   "incident": "",
      //   "incident_category": "",
      //   "current_status": "CREATED",
      //   "resident_uid": "2296a6b5-65fb-49a9-84e6-f2465a7b13c0",
      //   "qr_code_url": "https://www.communitytech.io/html/keymobile.html?key_id=bc83af3044e4&community=nautica2",
      //   "time_sent_to_visitor": "2025-03-02T20:50:44.000Z",
      //   "party_id": ""
      // }
    }
  },
  methods: {
    updateIncidentData(data) {
      console.log("Updating Incident Data", data)
      this.$modal.show(IncidentModal, {
        incident: data,
        userData: this.$props.userData,
        organizationData: this.$props.organizationData
      }, {
        transition: "fade",
        top: "0",
        width: "650",
        height: "auto",
        draggable: "true",
        adaptive: false,
        styles: "border-radius: 22px;"
      })
    },
    updateKeyData(data) {
      const isMobileOrTablet = isMobile || isTablet
      console.log("Updating Key Data", data)
      this.$modal.show(GateModal, {
        keyData: data,
        userData: this.$props.userData,
        organizationData: this.$props.organizationData
      }, {
        transition: "fade",
        top: isMobileOrTablet ? "0" : "40px",
        width: isMobileOrTablet ? "100%" : "600px",
        height: isMobileOrTablet ? "100%" : "auto",
        draggable: false,
        adaptive: false,
        styles: isMobileOrTablet
          ? `
          border-radius: 0px;
          margin: 0;
        `
          : `
          border-radius: 22px;
        `
      })
    }
  },
  created() {
    EventBus.$on(Constants.UPDATE_INCIDENT_MODAL_DATA, (data) => this.updateIncidentData(data));
    EventBus.$on(Constants.UPDATE_KEY_MODAL_DATA, (data) => {
      this.updateKeyData(data)
    });
  }
};
</script>

<style scoped>
.contentPane {
  width: calc(100% - 200px);
  margin: 0px;
  display: block;
  min-height: 88%;
  max-height: 90%;
  float: right;
  flex-shrink: 0;
  flex-grow: 1;
  flex-basis: auto;
}
</style>